<template>
  <c-layout :spinning="page.loading">
    <div class="home">
      <div class="count">
        <a-col :span="8">
          <a-select default-value="2021" style="width: 120px;border:none" @change="loadData()" v-model="form.year">
            <a-select-option :value="item.value" v-for="item in options.years">{{ item.label }}</a-select-option>
          </a-select>
          <p>年度</p>
        </a-col>
        <a-col :span="8" @click="loadData(item.code)" v-for="item in dataInfo.types">
          <p>{{ Math.round((item.dataList.length)) }}/{{ dataInfo.regCount }}/{{ item.math }}</p>
          <p>{{ item.name }}</p>
        </a-col>
      </div>
      <div class="home_wrapper">
        <div class="cont_box">
          <div class="cont cont1" v-for="item in options.govs">
            <h2><a>{{ item.name }}</a>（{{ item.count }}/{{ item.regions.length }}）</h2>
            <div class="unit_list">
              <ul>
                <span v-for="(item,index) in item.regions">
                    <li v-if="item.showColor" @click="clickOrg(item)" class="link upload">
                      <a-popover title="联系人信息" trigger="hover">
                        <template slot="content">
                         <span v-for="user in dataInfo.users">
                          <p v-if="item.id === user.regionId">姓名:{{ user.name }} | 电话:{{ user.phone }}</p>
                         </span>
                        </template>
                       {{ item.simpleName }}
                      </a-popover>
                    </li>
                    <li v-else @click="clickOrg(item)" class="link unupload">
                      <a-popover title="联系人信息" trigger="hover">
                          <template slot="content">
                           <span v-for="user in dataInfo.users">
                            <p v-if="item.id === user.regionId">姓名:{{ user.name }} | 电话:{{ user.phone }}</p>
                           </span>
                        </template>
                       {{ item.simpleName }}
                      </a-popover>
                    </li>
                </span>
                <div class="clearfix"/>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </c-layout>
</template>

<script>
import {CustomApis as api} from "@/api/CustomApis";
import {SysApis} from "@/api/SysApis";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import commonApi from "@/api/CommonApi";
import {getYears,defaultYear} from "@/utils/years.js";

export default {
  name: "publish-view",
  components: {},
  data() {
    return {
      locale,
      page: {
        loading: false,
      },
      form: {
        year: 2016,
        dataType: 0,
      },
      show: {
        hidden: false,
        selectYear: false
      },
      options: {
        years: getYears('1'),
        govs: [],
      },
      dataInfo: {
        types: [
          {
            name: '预算公示',
            code: 0,
            math: '0%',
            dataList: [],
          },
          {
            name: '决算公示',
            code: 1,
            math: '0%',
            dataList: [],
          }
        ],
        regCount: 0,
        users: [],
      }
    };
  },
  watch: {
  },
  activated() {
    this.initData()
  },
  mounted() {

  },
  methods: {
    initData() {
      this.$http.get(api.getGovList).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message)
          return
        }
        this.options.govs = result.data
        this.options.govs.sort((a, b) => {
          return b.sort - a.sort
        })
        let count = 0
        result.data.forEach(e => {
          e.regions.forEach(r => {
            count++;
          })
        })
        this.dataInfo.regCount = count
        this.loadData();
      })
      this.$http.get(SysApis.userList).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message)
          return
        }
        this.dataInfo.users = result.data
      })
    },
    getUserInfo() {
      return commonApi.getUserInfo().then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          return Promise.resolve({status: true, data: result.data})
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      })
    },
    loadData() {
      this.form.dataType = 0;
      let ysInfoList = new Array(),jsInfoList = new Array();
      this.$http.post(api.getPublishByStatus, this.form).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message)
          return
        }
        ysInfoList = result.data;
        this.form.dataType = 1;
        this.$http.post(api.getPublishByStatus, this.form).then(res => {
	        if (res.status !== 200) {
	          this.$message.error(result.message)
	          return
	        }
	        jsInfoList = res.data;
	        this.options.govs.forEach(e => {
	          e.count = 0
	          e.regions.forEach(r => {
	            r.showColor = false
	            let ysTemp = false,jsTemp = false;
	            ysInfoList.forEach((item) => {
	              if (r.id === item.region.id) {
	                ysTemp = true;
	                e.count++
	              }
	            });
	            jsInfoList.forEach((item) => {
	              if (r.id === item.region.id) {
	                jsTemp = true;
	                e.count++
	              }
	            });
	            if(ysTemp&&jsTemp){
	            	r.showColor = true
	            }
	          });
	        });
	        this.dataInfo.types[0].dataList = ysInfoList;
	        this.dataInfo.types[0].math = (ysInfoList.length / this.dataInfo.regCount*100).toFixed(2) + '%';
	        this.dataInfo.types[1].dataList = jsInfoList;
	        this.dataInfo.types[1].math = (jsInfoList.length / this.dataInfo.regCount*100).toFixed(2) + '%';
        });
      });
    },
    clickOrg(e) {
      let routeData = this.$router.resolve({
        path: '/info-list',
        query: {id: e.id}
      })
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style lang="less" scoped>
@import "~@public/reset.css";
@import "~@public/infoShow.css";

.home_wrapper .cont_box .cont .unit_list ul li:hover {
  cursor: default;
  background: -webkit-gradient(linear, left top, right bottom, from(#000), to(#000));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: normal;
  border-bottom: none;
}

.count {
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  display: flex;
}

.home_wrapper {
  display: flex;
}

.home_wrapper .cont_box {
  width: 100%;
  background: #fff;
  box-shadow: 0 0 2px #ccc;
  padding: 20px;
  margin: 0;
}

.link {
  color: #000
}

.upload {
  color: red
}

.unupload {
  color: #878585
}

/*滚动条整体样式*/
.file-list::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-right: 10px;
  opacity: 0.2;
}

/*滚动条里面小方块(滑块 )*/
.file-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}

/*滚动条里面轨道(背景)*/
.file-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  border-radius: 10px;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}
</style>
